var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFallenD = function SvgFallenD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410 164"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62B1E",
    d: "M42.898 54h-41V16h127v38h-41v109h-45zm93-38h124v38h-78v18h78v35h-78v18h78v38h-124zM313.79 157.054l17.24.02c26.116 0 28.846-3.57 28.19-5.726-.441-1.444-4.171-5.402-30.025-5.402h-13.067zM278.671 140h62.027c35.125 0 52.393 5.66 57.359 11.445C404.103 158.49 384.142 163 332.966 163h-66.068z"
  })));
};
export default SvgFallenD;